import { render, staticRenderFns } from "./dashboard_admin_brand.vue?vue&type=template&id=2402ee02"
import script from "./dashboard_admin_brand.vue?vue&type=script&lang=js"
export * from "./dashboard_admin_brand.vue?vue&type=script&lang=js"
import style0 from "./dashboard_admin_brand.vue?vue&type=style&index=0&id=2402ee02&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports